import { authHeader } from "../../../helpers/authHeader";
import { handleResponse } from "../../../helpers/handleresponse";

export const emailService = {
  update,
  get,
  sendTest,
  getAll
}

async function getAll(eventId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })

  };
  return fetch(`./api/com/getall/` + eventId, requestOptions)
    .then(handleResponse)
    .then(communications => {
      return communications;
    });
}

async function get(communicationId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" })

  };
  return fetch(`./api/com/` + communicationId, requestOptions)
    .then(handleResponse)
    .then(communication => {
      return communication;
    });
}
async function update(communication) {
  const { comContentId, eventId, type, name, subject, body, bodyJson, templateId, previewText, fromName, fromAddr, previewImage, rawBody, inherit, updatedUserId, updated, inserted, bcc, useLinktrack } = communication;
  const newMail = {
    comContentId, eventId, type, name,
    subject, body, bodyJson, templateId, previewText, fromName, fromAddr, rawBody,
    previewImage, inherit, updatedUserId, updated, inserted, bcc, useLinktrack
  }
  const requestOptions = {
    method: "PUT",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(newMail)
  };

  return fetch(`./api/com`+window.location.search, requestOptions)
    .then(handleResponse)
    .then(communication => {
      return communication;
    });
}

async function sendTest(email) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(email)
  };

  return fetch(`./api/com/sendTest`, requestOptions)
    .then(handleResponse);
}


